import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n';
import LanguageSwitcher from './LanguageSwitcher';
import RefreshButton from './RefreshButton';

export default function Header() {
  const { t } = useLanguage();
  return (
    <header className="site-header">
      <div className="header-content">
        <img
          src="/images/logotransparent.png"
          alt="RetroGameUp"
          className="header-logo"
        />
        <div className="header-text">
          <h1>
            <Link to="/">{t('siteTitle')}</Link>
          </h1>
          <p>{t('siteSubtitle')}</p>
        </div>
      </div>
      <div className="header-actions">
        <RefreshButton />
        <LanguageSwitcher />
      </div>
    </header>
  );
}
